import React from 'react'
import moment from 'moment'
import injectStyles from 'react-jss'
import images from '../../../../Assets/Images'

const CampaignPrintingPlan = props => {
  const { children, classes } = props

  return (
    <div>
      <div className={classes.topContainer}>
        <div>
          <h1 className={classes.header}>Campaign printing plan</h1>
          <span>Generated at:</span>
          <span>{moment().format('DD/M/YYYY')}</span>
        </div>
        <img
          className={classes.topContainerLogo}
          src={images.mainLogo}
          alt="Logo"
        />
      </div>
      {children}
    </div>
  )
}

const styles = {
  header: {
    fontSize: 28,
    marginTop: 24,
  },
  topContainer: { display: 'flex', justifyContent: 'space-between' },
  topContainerLogo: { height: 100 },
}

export default injectStyles(styles)(CampaignPrintingPlan)
